
export const typeBadgeMap = {
    BELL: { label: "घण्टी", colorScheme: "green" },
    NATIONAL_ANTHEM: { label: "राष्ट्रिय गान", colorScheme: "blue" },
    MUSIC: { label: "संगीत", colorScheme: "purple" },
};